export function defaultChecked() {
    $('input[name="brand"]').attr('checked', 'checked').parent().removeClass('btn-light').addClass('btn-primary');
    $('input[name="orientation"]').attr('checked', 'checked').parent().removeClass('btn-light').addClass('btn-primary');
    $('input[name="body_shape"]').attr('checked', 'checked').parent().removeClass('btn-light').addClass('btn-primary');
    $('input[name="price"]').attr('checked', 'checked').parent().removeClass('btn-light').addClass('btn-primary');
}

export function checkFacet() {
    $('#similarForm :checkbox').on('change', function() {
        $(this).attr('checked', 'checked').parent('.btn').toggleClass(['btn-primary', 'btn-light']);
        filterModels();
    });
}

function filterModels() {
    var brands = [];
    var orientations = [];
    var number_of_strings = [];
    var configurations = [];
    var body_shapes = [];
    var body_materials = [];
    var colors = [];
    var fingerboards = [];
    var prices = [];
    $("input[name='brand']:checked").each(function(){ brands.push($(this).val()); });
    $("input[name='orientation']:checked").each(function(){ orientations.push($(this).val()); });
    $("input[name='number_of_string']:checked").each(function(){ number_of_strings.push($(this).val()); });
    $("input[name='configuration']:checked").each(function(){ configurations.push($(this).val()); });
    $("input[name='body_shape']:checked").each(function(){ body_shapes.push($(this).val()); });
    $("input[name='body_material']:checked").each(function(){ body_materials.push($(this).val()); });
    $("input[name='color']:checked").each(function(){ colors.push($(this).val()); });
    $("input[name='fingerboard']:checked").each(function(){ fingerboards.push($(this).val()); });
    $("input[name='price']:checked").each(function(){
        var price = $(this).val();
        price = parseInt(price)*0.9 + "-" + parseInt(price)*1.1;
        prices.push(price);
    });

    var data = {
        brands: brands,
        orientations: orientations,
        number_of_strings: number_of_strings,
        configurations: configurations,
        body_shapes: body_shapes,
        body_materials: body_materials,
        colors: colors,
        fingerboards: fingerboards,
        prices: prices
    };
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $.ajax({
        method: $('#similarForm').attr('method'),
        url: $('#similarForm').attr('action'),
        data: data,
        beforeSend:function(){
            $("#similars").html('<div class="loader"><div class="loader-spinner"></div></div>');
        }
    }).done(function(result) {
        $("#similars").html(result);
    }).fail(function(result) {
        // console.log('fail', result);
        // $.each(data.responseJSON, function (key, value) {
        //     console.log(value);
        // });
    });
}